import CaretLeft from 'assets/icons/landing/caret-left'
import CaretRight from 'assets/icons/landing/caret-right'
import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

type StepsNavigationProps = {
  direction: 'left' | 'right'
}

export default function StepsNavigation({ direction }: StepsNavigationProps) {
  const { t } = useTranslation('landing')

  if (direction === 'left') {
    return (
      <button className='swiper-button-prev z-15 rounded-full bg-secondary py-2 px-5 flex items-center gap-3 absolute text-main bottom-6 left-0 lg:left-[5%] sm:-top-32 sm:bottom-[unset] z-[9999] disabled:hidden'>
        <CaretLeft /> {t('steps-section.btn-prev')}
      </button>
    )
  }

  if (direction === 'right') {
    return (
      <button className='swiper-button-next z-15 rounded-full bg-secondary py-2 px-5 flex items-center gap-3 absolute text-main bottom-6 right-0 lg:right-[5%] sm:-top-32 sm:bottom-[unset] z-[9999] disabled:hidden'>
        {t('steps-section.btn-next')} <CaretRight />
      </button>
    )
  }

  return <Fragment></Fragment>
}
